export enum RudderEvent {
  ACCOUNT_CREATION_FAILED = 'Account Creation Failed',
  AVAILABLE_PROVIDERS_SHOWN = 'Available Providers Shown',
  BASIC_INFORMATION_GIVEN = 'Basic Information Given',
  BILLING_DETAILS_DATE_CHANGED = 'Billing Details date changed',
  BILLING_DETAILS_PAGE_VIEWED = 'Billing page viewed',
  BOOKING_CONSENT_GIVEN = 'Booking Consent Given',
  BOOKING_COMPLETED = 'Booking Completed',
  BOOKING_CONFIRMED = 'Booking Confirmed',
  CLIENT_LIST_PAGE_VIEWED = 'Client List Page Viewed',
  CLIENT_PAGE_COMMUNICATION_HISTORY_VIEWED = 'Client Page Communication History Viewed',
  CLIENT_PAGE_CONSENT_VIEWED = 'Client Page Consent Viewed',
  CLIENT_PAGE_INSURANCE_DETAILS_VIEWED = 'Client Page Insurance Details Viewed',
  CLIENT_PAGE_SESSIONS_VIEWED = 'Client Page Sessions Viewed',
  CLIENT_PAGE_SUPPORT_BILLING_VIEWED = 'Client Page Support/Billing Viewed',
  CLOSED_FIRESIDE_COURSE = 'Pressed Back on Fireside Course Detail Page',
  FIRESIDE_COURSE_DESCRIPTION_CLICK = 'Fireside Course Description Clicked',
  INSURANCE_VALIDATION_RECEIVED = 'Insurance Validation Received',
  INSURANCE_VALIDATION_RECEIVED_ERROR = 'Insurance Validation Received Error',
  INSURANCE_VALIDATION_REQUESTED = 'Insurance Validation Requested',
  INSURANCE_VALIDATION_SHOWN = 'Insurance Validation Shown',
  INSURANCE_USER_DECISION = 'Insurance User Decision',
  INSURANCE_VALIDATION_WIDGET_RECEIVED = 'Insurance Validation Widget Received',
  INSURANCE_VALIDATION_WIDGET_RECEIVED_ERROR = 'Insurance Validation Widget Received Error',
  INSURANCE_VALIDATION_WIDGET_REQUESTED = 'Insurance Validation Widget Requested',
  BOOKING_PAYMENT_METHOD_CHANGED = 'Booking Payment Method Changed',
  LOGIN_CTA_CLICKED = 'Signup/Login CTA clicked',
  MAGIC_LINK_RESENT = 'Magic link resent',
  OPENED_FIRESIDE = 'Fireside Click',
  PAY_NOW_CLICK = 'Pay now clicked',
  PAYMENT_RECEIPT_PDF_DOWNLOAD = 'Client Dashboard Payment Receipt Downloaded',
  PDF_DOCUMENT_VIEWED = 'PDF Document Viewed',
  PROVIDER_MY_SCHEDULE_VIEWED = 'Provider My Schedule Viewed',
  PROVIDER_PAGE_LINK_CLICKED = 'Provider Profile Page Navigation Selected',
  PROVIDER_VIDEO_ENGAGEMENT = 'Provider Video Engagement',
  PROVIDER_VIDEO_STARTED = 'Provider Video Started',
  PROVIDER_SLOT_SELECTED = 'Provider Slot Selected',
  PROVIDER_ZOOM_LAUNCHED = 'Provider Zoom Launched',
  PROVIDERS_PROFILE_PAGE_VIEWED = 'Providers Profile Page Viewed',
  PROVIDER_PROFILE_LICENSED_IN_LINK_CLICKED = 'Provider Profile Licensed In Link Clicked',
  PROVIDER_PROFILE_CLINICAL_SUPERVISOR_LINK_CLICKED = 'Provider Profile Clinical Supervisor Link Clicked',
  PROVIDER_PROFILE_SECTION_TOGGLED = 'Provider Profile Section Toggled',
  PROVIDER_PROFILE_SERVICE_TYPE_LINK_CLICKED = 'Provider Profile Service Type Link Clicked',
  PROVIDER_BILLING_NOTES_VIEW = 'Provider Billing/Support Notes Viewed',
  PROVIDER_DAILY_SCHEDULE_CONSENT_VIEW = 'Provider Client Consent Viewed from Daily Schedule',
  PROVIDER_SESSION_HISTORY_CONSENT_VIEW = 'Provider Client Consent Viewed from Client Session History',
  PROVIDER_CLIENT_SESSION_VIEW = 'Provider Client Sessions Viewed',
  REBOOKING_BUTTON_CLICK = 'Book Again Clicked',
  REBOOKING_SLOT_SELECTED = 'Rebooking Slot Selected',
  REMOVE_THIS_CLIENT_CLICKED = 'Remove This Client Clicked',
  REMOVE_THIS_CLIENT_CONFIRMATION = 'Remove This Client Confirmation',
  RP_NOT_CREATED = 'Responsible party not created',
  SEEK_FIRESIDE_LESSON_VIDEO = 'Fireside Chapter Video Seeked',
  SELECTED_FIRESIDE_COURSE = 'Fireside Course View',
  SLOTS_SHOWN_FOR_PROVIDER_REBOOKING = 'Slots Shown for Rebooking Provider',
  SE_FRIENDLY_PROVIDER_LISTING = 'Local Provider Listing Shown',
  SESSION_CANCELLED = 'Session Cancelled',
  PROVIDER_PROFILE_PAGE_AVAILABILITY_SHOWN = 'Provider Profile Page Availability Shown',
  VIEW_FIRESIDE_LESSON_VIDEO = 'Fireside Chapter Video View',
  INSURANCE_VERIFICATION_HISTORY_VIEWED = 'Insurance Verification History Viewed',
  INSURANCE_VERIFICATION_HISTORY_LINE_ITEM_VIEWED = 'Insurance Verification History Line Item Viewed',
  PVERIFY_VERFIFICATION_VIEWED = 'pVerify Verification Viewed',
  PATIENT_EDITED_BY_SUPPORT_BEFORE_FIRST_APPOINTMENT = 'Patient Edited By Support Before First Appointment',
  SE_FRIENDLY_SEARCH_CLICKED = 'SE Friendly Search Clicked',
  SE_FRIENDLY_SEARCH_OPTION_SELECTED = 'SE Friendly Search Option Selected',
  BOOKING_CONSENT_MODAL_VIEWED = 'Booking Consent Modal Viewed',
  PHONE_NUMBER_CLICKED = 'Phone Number Clicked',
  BOOKING_LOGIN_MODAL_SHOWN = 'Booking Login Modal Shown',
  BOOKING_LOGIN_MODAL_EMAIL_SUBMITTED = 'Booking Login Modal Email Submitted',
  BOOKING_LOGIN_MODAL_LOGGED_IN = 'Booking Login Modal Logged In',
  BOOKING_FAILED = 'Booking Failed',
  BOOKING_WARNED = 'Booking Warned',
  BOOKING_CROSS_STATE_WARNING_SHOWN = 'Booking Cross State Warning Shown',
  BOOKING_CTA_CLICKED = 'Booking CTA Clicked',
  DASHBOARD_BOOK_NOW_CLICKED = 'Dashboard Book Now Clicked',
  PATIENT_CARE_PAUSED = 'Patient Care Paused',
  BOOKING_RESCHEDULED = 'Booking Rescheduled',
  BOOKING_NEXT_OPENING_CLICKED = 'Booking Next Opening Clicked',
  BOOKING_MODAL_ALL_AVAILABILITY_SHOWN = 'Booking Modal All Availability Shown',
  BOOKING_TOOL_SHOW_MAP_CLICKED = 'Booking Tool Show Map Clicked',
  BOOKING_TOOL_HIDE_MAP_CLICKED = 'Booking Tool Hide Map Clicked',
  MEDICAID_USER_RETURNED = 'Medicaid User Returned',
  SHOW_PARTIAL_MATCHES_CLICKED = 'Booking Show Partial Matches Clicked',
  BOOKING_MODAL_OUT_OF_NETWORK_SHOWN = 'Booking Modal Out Of Network Shown',
  BOOKING_MODAL_OUT_OF_NETWORK_INTERACTION = 'Booking Modal Out Of Network Interaction',
  BOOKING_CROSS_STATE_WARNING_SUPPRESSED = 'Booking Cross State Warning Suppressed',
  BOOKING_CROSS_STATE_BLOCK_SHOWN = 'Booking Cross State Block Shown',
  BOOKING_CROSS_STATE_BLOCK_INTERACTION = 'Booking Cross State Block Interaction',
  BOOKING_CROSS_STATE_PROVIDER_SWITCHED = 'Booking Cross State Provider Switched',
  BOOKING_CROSS_STATE_WARNING_INTERACTION = 'Booking Cross State Warning Interaction',
  ALTERNATE_CLINICIAN_STATE_NOT_ACTIVE = 'alternate_clinician_state_not_active',
  LOGIN_EMAIL_SUBMITTED = 'Login Email Submitted',
  SUCESSFULLY_LOGGED_IN = 'Sucessfully Logged In',
  SIMILAR_PROVIDER_SHOWN = 'Similar Providers Shown',
  SEE_AVAILABLE_PROVIDER_CLICKED = 'See Available Providers Clicked',
  PRE_SEARCH_QUESTIONNAIRE_SERVICE_TYPE_AND_LOCATION_SELECTED = 'Pre Search Questionnaire Service Type And Location Selected',
  PRE_SEARCH_QUESTIONNAIRE_CHILD_AGE_SELECTED = 'Pre Search Questionnaire Child Age Selected',
  PRE_SEARCH_QUESTIONNAIRE_INSURANCE_SELECTED = 'Pre Search Questionnaire Insurance Selected',
  PRE_SEARCH_QUESTIONNAIRE_COMPLETED = 'Pre Search Questionnaire Completed',
  PRE_SEARCH_QUESTIONNAIRE_SKIPPED = 'Pre Search Questionnaire Skipped',
  TASK_STARTED = 'Task Started',
  PSYCHIATRY_REFERRAL_CONSIDERATIONS_CLICKED = 'Psychiatry Referral Considerations Clicked',

  //Booking v2 Events
  BOOKING_FLOW_STARTED = 'Booking Flow Started',
  CHANGE_SERVICE_CONFIRM = 'Change Service Confirm',
  BOOKING_FLOW_COMPLETED = 'Booking Flow Completed',
  BOOKING_FLOW_ACCOUNT_CREATED = 'Booking Flow Account Created',
  BOOKING_FLOW_ACCOUNT_CREATION_FAILED = 'Booking Flow Account Creation Failed',
  BOOKING_FLOW_CLIENT_DETAILS_OPENED = 'Booking Flow Client Details Opened',
  BOOKING_FLOW_CLIENT_DETAILS_COMPLETED = 'Booking Flow Client Details Completed',
  //Booking v2 consents events
  BOOKING_FLOW_CONSENTS_OPENED = 'Booking Flow Consents Opened',
  BOOKING_SERVICES_AGREEMENT_MODAL_OPENED = 'Booking Services Agreement Modal Opened',
  BOOKING_SERVICES_AGREEMENT_MODAL_COMPLETED = 'Booking Services Agreement Modal Completed',
  BOOKING_TERMS_OF_SERVICE_MODAL_OPENED = 'Booking Terms of Service Modal Opened',
  BOOKING_TERMS_OF_SERVICE_MODAL_COMPLETED = 'Booking Terms of Service Modal Completed',
  BOOKING_FLOW_CONSENTS_COMPLETED = 'Booking Flow Consents Completed',
  BOOKING_FLOW_BILLING_DETAILS_OPENED = 'Booking Flow Billing Details Opened',
  BOOKING_FLOW_BILLING_DETAILS_COMPLETED = 'Booking Flow Billing Details Completed',
  //Booking v2 insurance events
  BOOKING_FLOW_SESSION_COVERAGE_OPENED = 'Booking Flow Session Coverage Opened',
  BOOKING_FLOW_SESSION_COVERAGE_COMPLETED = 'Booking Flow Session Coverage Completed',
  BOOKING_V2_COPAY_DISPLAY_SHOWN = 'Booking V2 Copay Display Shown',
  BOOKING_V2_COPAY_DETAILS_CLICKED = 'Booking V2 Copay Details Clicked',
  // Optional group # field on the insurance step (THRIV-14202, monitoring in THRIV-15196)
  BOOKING_V2_GROUP_NUMBER_FIELD_SHOWN = 'Booking V2 Group Number Field Shown',
  BOOKING_V2_GROUP_NUMBER_SAMPLE_CARD_CLICKED = 'Booking V2 Group Number Sample Card Clicked',
  BOOKING_V2_GROUP_NUMBER_SUBMITTED = 'Booking V2 Group Number Submitted',
  REFER_CLIENT = 'Refer Client action selected',
  // Psych cross-promote module on the booking confirmation screen (fc-059).
  // The "shown" event is the denominator for attach-rate reporting.
  PSYCH_CROSS_PROMOTE_MODULE_SHOWN = 'Psych Cross Promote Module Shown',
  PSYCH_CROSS_PROMOTE_CTA_CLICKED = 'Psych Cross Promote CTA Clicked',
  BOOKING_CONFIRMATION_LINK_CLICKED = 'Booking Confirmation Link Clicked',

  // Safety Plan (Facesheet)
  SAFETY_PLAN_STATUS_VIEWED = 'Safety Plan Status Viewed',
  SAFETY_PLAN_OPENED = 'Safety Plan Opened',
  SAFETY_PLAN_SEND_FOR_SIGNATURE_CLICKED = 'Safety Plan Send For Signature Clicked',
  SAFETY_PLAN_DRAFT_SAVED = 'safety_plan_draft_saved',
  SAFETY_PLAN_SENT_TO_CLIENT = 'safety_plan_sent_to_client',
  SAFETY_PLAN_LOADED_SUCCESSFULLY = 'Safety Plan Loaded Successfully',

  // NENA Events
  NENA_SEARCH_QUERY = 'NENA Search Query',

  // Reports Events
  REPORTS_LINK_CLICKED = 'Reports Link Clicked',

  // Lead Generation Events
  LEAD_GEN_FORM_INITIATED_REACT = 'Lead Gen Form Initiated React',
  NEWSLETTER_EMAIL_SUBMITTED = 'Newsletter Email Submitted',

  CALENDAR_MODAL_OPENED = 'Calendar Modal Opened',
  CALENDAR_DATE_SELECTED = 'Calendar Date Selected',
  CALENDAR_VISIT_TYPE_CHANGED = 'Calendar Visit Type Changed',
  // Primary Book Button A/B Test Events
  PROVIDER_PROFILE_DAY_NAVIGATION_CLICKED = 'Provider Profile Day Navigation Clicked',
  PROVIDER_PRIMARY_BOOK_BUTTON_CLICKED = 'Provider Primary Book Button Clicked',

  // Blind booking (book-next-available) events
  BLIND_BOOKING_STARTED = 'Blind Booking Started',
  BLIND_BOOKING_MODAL_SHOWN = 'Blind Booking Modal Shown',
  BLIND_BOOKING_INSURANCE_SELECTED = 'Blind Booking Insurance Selected',
  BLIND_SLOT_SELECTED = 'Blind Slot Selected',
  BLIND_BOOKING_FLOW_SKIPPED = 'Blind Booking Flow Skipped',
  BLIND_BOOKING_BACK_CTA_CLICKED = 'Blind Booking back CTA clicked',

  // Partner Referral Portal — login flow (THRIV-13360)
  PORTAL_LOGIN_EMAIL_SUBMITTED = 'portal_login_email_submitted',
  PORTAL_LOGIN_OTP_SUBMITTED = 'portal_login_otp_submitted',
  PORTAL_LOGIN_SUCCESS = 'portal_login_success',
  PORTAL_LOGIN_FAILED = 'portal_login_failed',

  // CC Reminder Events
  CC_REMINDER_SENT = 'CC Reminder Sent',

  // Osano consent events — React parity with WordPress (THRIV-15239)
  OSANO_BANNER_DISPLAYED = 'osano_banner_displayed',
  OSANO_CONSENT_SAVED = 'osano_consent_saved',
  OSANO_CONSENT_SNAPSHOT = 'osano_consent_snapshot',
  OSANO_PREFERENCES_DRAWER_OPENED = 'osano_preferences_drawer_opened',
  OSANO_SCRIPT_BLOCKED = 'osano_script_blocked',
}
